export default __webpack_public_path__ + "static/Tempoist3.inline-64e6c586d506afb4e1aa479f58b33fa7.png";